import { useEffect } from 'react';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import Switch from 'components/ui/Switch';
import Card from 'components/ui/Card';
import Alert from 'components/ui/Alert';
import { LOG_SUMMARY_OPTION } from 'constants/general';
import { t } from 'services/i18n.service';
import {
  updateMoreOptionLogQuantity,
  updateMoreOptionLogQuantityQuestions,
  updateMoreOptionLogSummaryType
} from 'store/reducer/modal/slice';
import { moreOptionModalActivitySelector } from 'store/reducer/modal/more-options.modal.selectors';
import { activityHasPerChoiceLogging } from 'utils/log-quantity-questions.util';

const EnableDataLogging: React.FC = () => {
  const dispatch = useAppDispatch();
  const activity = useAppSelectorShallow(moreOptionModalActivitySelector);
  const hasPerChoiceLogging = activity
    ? activityHasPerChoiceLogging(activity)
    : false;
  const isDataLoggingEnabled = hasPerChoiceLogging
    ? false
    : (activity?.log_quantity ?? false);

  useEffect(() => {
    if (!hasPerChoiceLogging) {
      return;
    }
    dispatch(updateMoreOptionLogQuantity(false));
    dispatch(updateMoreOptionLogQuantityQuestions([]));
    dispatch(updateMoreOptionLogSummaryType(LOG_SUMMARY_OPTION.SUMMATION));
  }, [hasPerChoiceLogging, dispatch]);

  const handleToggle = (checked: boolean) => {
    if (hasPerChoiceLogging) {
      return;
    }
    dispatch(updateMoreOptionLogQuantity(checked));
    if (!checked) {
      dispatch(updateMoreOptionLogQuantityQuestions([]));
    }
  };

  return (
    <Card className='flex flex-col ~gap-2/3'>
      <div className='flex items-start justify-between ~gap-4/6'>
        <div className='flex-1 flex flex-col ~gap-1/2'>
          <div className='flex items-center ~gap-2/3'>
            <Switch
              checked={isDataLoggingEnabled}
              onChange={handleToggle}
              disabled={hasPerChoiceLogging}
              size='medium'
              variant='default'
            />
            <span className='~text-xs/base font-medium text-black dark:text-white'>
              {t('tabs_revamp.log_data_tab.enable_data_logging')}
            </span>
          </div>
          <p className='~text-xs/sm text-gray-600 dark:text-gray-400 ~ml-0/0'>
            {t('tabs_revamp.log_data_tab.enable_data_logging_description')}
          </p>
          {hasPerChoiceLogging && (
            <Alert
              message={t('tabs_revamp.log_data_tab.logging_on_choices_only')}
              variant='info'
              style='bordered'
              size='small'
            />
          )}
        </div>
      </div>
    </Card>
  );
};

export default EnableDataLogging;
